import type { ClientRole } from './types';

const ORDER: Record<ClientRole, number> = { user: 0, admin: 1, 'super-admin': 2 };

const LABELS: Record<ClientRole, string> = {
  user: 'user',
  admin: 'admin',
  'super-admin': 'super admin',
};

export function hasAtLeast(role: ClientRole | null | undefined, min: ClientRole): boolean {
  return !!role && ORDER[role] >= ORDER[min];
}

export function hasClientRole(role: ClientRole | null | undefined): role is ClientRole {
  return !!role && role in ORDER;
}

export function clientRoleLabel(role: ClientRole | null | undefined): string {
  return hasClientRole(role) ? LABELS[role] : 'no role';
}
